import React, { useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { initializeGA, trackPageView } from './utils/analytics';
import StructuredData from './components/StructuredData';
import CanonicalTags from './components/CanonicalTags';
import Header from './components/Header';
import PromoBanner from './components/PromoBanner';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Products from './pages/Products';
import ServiceCategory from './pages/ServiceCategory';
import MothersDay from './pages/MothersDay';
// import NotFound from './pages/NotFound';
import './App.css';

// Component to track page views
function Analytics() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname, document.title);
  }, [location]);
  
  return null;
}

function App() {
  const initGA = useCallback(() => {
    const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;
    if (measurementId) {
      initializeGA(measurementId);
    }
  }, []);

  useEffect(() => {
    initGA();
  }, [initGA]);

  return (
    <Router>
      <div className="App">
        <StructuredData />
        <CanonicalTags />
        <Analytics />
        <Header />
        <PromoBanner />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/products" element={<Products />} />
            <Route path="/services/:category" element={<ServiceCategory />} />
            <Route path="/mothers-day" element={<MothersDay />} />
            {/* Redirect old/invalid services pages */}
            <Route path="/services-3" element={<Navigate to="/services" replace />} />
            <Route path="/services-/*" element={<Navigate to="/services" replace />} />
            {/* Catch-all 404 route */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;